import { render } from "./loading-screen.vue?vue&type=template&id=48ead428"
import script from "./loading-screen.vue?vue&type=script&lang=js"
export * from "./loading-screen.vue?vue&type=script&lang=js"

import "./loading-screen.vue?vue&type=style&index=0&id=48ead428&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__